import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/warehouse/consumable/type/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/warehouse/consumable/type/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/warehouse/consumable/type/updateStatus', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/warehouse/consumable/type/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/warehouse/consumable/type/update', params,options);

export const lazyTreeListByParentId = (params, options) =>
  request.get('/api/v4ward/warehouse/consumable/type/lazy-list-parentId', Object.assign({}, options, { params }));

export const lazyList = (params, options) =>
  request.get('/api/v4ward/warehouse/consumable/type/lazy-list', Object.assign({}, options, { params }));

export const tree = (params, options) =>
  request.get('/api/v4ward/warehouse/consumable/type/tree', Object.assign({}, options, { params }));

export const treeFree = (params, options) =>
  request.get('/api/v4ward/warehouse/consumable/type/treeFree', Object.assign({}, options, { params }));
treeFree
